import { DefaultTheme } from '../../components/theme';

export const CSS = {
	container: 'c-AssetTypeCustomizer',
	section: 'c-AssetTypeCustomizer__section',
	caption: 'c-AssetTypeCustomizer__caption',
	preview: 'c-AssetTypeCustomizer__preview',
	iconGrid: 'c-AssetTypeCustomizer__iconGrid',
	chip: 'c-AssetTypeCustomizer__chip',
	chipActive: 'c-AssetTypeCustomizer__chip--active',
	chipIcon: 'c-AssetTypeCustomizer__chipIcon',
};

export const PREVIEW_SIZE = 40;

const ICON_COLUMNS = 6;
const ICON_GRID_GAP = parseInt(DefaultTheme.space(2));
const CHIP_WIDTH = 36;
const CHIP_HORIZONTAL_BORDER_AND_PADDING = 19; // 1.5px border + 8px padding, each side

/** The icon grid's own rendered width: `ICON_COLUMNS` chips (each `CHIP_WIDTH` + its own border/padding), plus the gaps between them. */
export const ICON_ROW_WIDTH =
	ICON_COLUMNS * (CHIP_WIDTH + CHIP_HORIZONTAL_BORDER_AND_PADDING) + (ICON_COLUMNS - 1) * ICON_GRID_GAP;

const SCROLLBAR_ALLOWANCE = 20;
export const POPOVER_WIDTH = ICON_ROW_WIDTH + 2 * ICON_GRID_GAP + SCROLLBAR_ALLOWANCE;

export const Style = {
	[CSS.container]: { display: 'flex', 'flex-direction': 'column', gap: DefaultTheme.space(4) },
	[CSS.section]: { display: 'flex', 'flex-direction': 'column', gap: DefaultTheme.space(2) },
	[CSS.caption]: {
		'font-size': '11px',
		'font-weight': 'bold',
		'letter-spacing': '0.5px',
		'text-transform': 'uppercase',
		color: DefaultTheme.font.color.supporting,
	},
	[CSS.preview]: {
		display: 'flex',
		'align-items': 'center',
		'justify-content': 'center',
		'box-sizing': 'border-box',
		width: `${ICON_ROW_WIDTH}px`,
		'min-height': '40px',
		padding: `${DefaultTheme.space(2)} ${DefaultTheme.space(3)}`,
		background: DefaultTheme.background.offWhite,
		border: `1px solid ${DefaultTheme.font.color.divider}`,
		'border-radius': '6px',
	},
	[CSS.iconGrid]: {
		display: 'grid',
		width: `${ICON_ROW_WIDTH}px`,
		'grid-template-columns': `repeat(${ICON_COLUMNS}, minmax(0, 1fr))`,
		gap: `${ICON_GRID_GAP}px`,
	},
	[CSS.chip]: {
		display: 'flex',
		'align-items': 'center',
		'justify-content': 'center',
		width: '100%',
		'box-sizing': 'border-box',
		padding: DefaultTheme.space(2),
		cursor: 'pointer',
		background: DefaultTheme.background.offWhite,
		border: `1.5px solid ${DefaultTheme.font.color.divider}`,
		'border-radius': '7px',
	},
	[`${CSS.chip}:hover`]: { background: DefaultTheme.background.lightGrey },
	[CSS.chipActive]: {
		'border-color': DefaultTheme.color.accent,
		background: DefaultTheme.background.lightGrey,
	},
	[CSS.chipIcon]: { display: 'flex', 'align-items': 'center', 'justify-content': 'center', height: '20px' },
};
